const MY_PAYCODE = 'myPaycode';
const MY_SHIFT = 'myShift';
const OPEN_SHIFT = 'openShift';
const SHIFT_SWAP = 'shiftSwap';
const TO_COVER = 'toCover';
const VOLUNTARY_TIME_OFF = 'voluntaryTimeOff';

export const RequestTypes = Object.freeze({
    [TO_COVER]: 0,
    [SHIFT_SWAP]: 1,
    [OPEN_SHIFT]: 2,
    [VOLUNTARY_TIME_OFF]: 3,
});


export const ListViewRequestTypes = Object.freeze({
    [MY_PAYCODE]: -2,
    [MY_SHIFT]: -1,
    [TO_COVER]: 0,
    [SHIFT_SWAP]: 1,
    [OPEN_SHIFT]: 2,
    [VOLUNTARY_TIME_OFF]: 3,
});

export const RequestTypeNames = Object.freeze({
    0: TO_COVER,
    1: SHIFT_SWAP,
    2: OPEN_SHIFT,
    3: VOLUNTARY_TIME_OFF,
});

export const RequestActionType = Object.freeze({
    Cover: 'Cover',
    Swap: 'Swap',
    OpenShift: 'OpenShift',
    VoluntaryTimeOff: 'VoluntaryTimeOff'
});

export const RequestTypeColors = Object.freeze({
    [TO_COVER]: '#ffdd00',
    [SHIFT_SWAP]: '#FF7A59',
    [OPEN_SHIFT]: '#EE0F0F',
    [VOLUNTARY_TIME_OFF]: '#006600',
});


